import { render, staticRenderFns } from "./ContentSwitcher.vue?vue&type=template&id=462b9989&scoped=true&"
import script from "./ContentSwitcher.vue?vue&type=script&lang=js&"
export * from "./ContentSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ContentSwitcher.vue?vue&type=style&index=0&id=462b9989&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b9989",
  null
  
)

export default component.exports